module.exports = __webpack_public_path__ + "static/img/Folder.1a52d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/design/Folder.png
// module id = znuF
// module chunks = 0